import _ from 'lodash'
import {Modal} from 'iview'
import router from '../router'
import {apiFactory} from './index'
import request from './request'
import Vue from 'vue'
import SM2 from "@/zpa/sm2-util";

const api = apiFactory('admin')
const apiAuth = apiFactory('auth');
const loginAuth = apiFactory('usercenter');

export const goLogin = _.debounce((confirm) => {
  if (confirm === false) {
    return router.replace({
      name: 'login',
    })
  }

  // Modal.warning({
  //   title: '登录',
  //   content: '您所访问的页面需要登录，即将跳转到登录页面。',
  //   onOk() {
  //     router.replace({
  //       name: 'login',
  //     })
  //   },
  // })
}, 400)

export function checkLogin() {
  return api.get('/system/mainframe/hasLogin')
    .then(res => res.data)
}

export function login2({username, password}) {
  return loginAuth.post('/usercenter/login2', {
    password,
    username,
    ajax: true,
  }).then(res => res.data.data)
}

export function login3({username, password, uuid, checkcode}) {
  const data = {
    username,
    password,
    ajax: true,
    uuid,
    checkcode
  }
  data.password = SM2.doEncrypt(data.password)
  return request({
    url: '/auth/newlogin/login',
    method: 'post',
    data: data
  })
}

export function userIsNeedValid(loginName) {
  return request({
    url: '/auth/newlogin/userIsNeedValid?loginName='+loginName,
    method: 'get'
  })
}

export function ssologin({username, password, uuid, checkcode,clientId}) {
  const data = {
    username,
    password,
    ajax: true,
    uuid,
    checkcode,
    clientId
  }
  return request({
    url: '/auth/sso/login',
    method: 'post',
    data: data
  })
}
export function ssoTokenLogin(id) {
  return request({
    url: `/auth/sso/login?id=${id}`,
    method: 'get',
  })
}

export function getInfo() {
  return request({
    url: '/auth/newlogin/info/SC',
    method: 'get'
  })
}

export function bindScUser(data) {
  return request({
    url: '/auth/jscz/bindScUser',
    method: 'post',
    data: data
  })
}

export function login({username, password}) {
  return apiAuth.post('/login', {
    password,
    username,
    ajax: true,
  }).then(res => res.data)
}

export function loginout() {
  Vue.IM = ''
  return apiAuth.post('/logout').then(res => res.data)
}
/**
 * 获取当前用户信息
 */
export function getCurrentuser() {
  return api.get('/system/mainframe/currentuser')
    .then(res => res.data)
}

export function checkpwd(password) {
  return api.post('/system/mainframe/checkpwd', {
    ...password,
    ajax: true,
  }).then(res => res.data)
}
export function justPasswordExpired() {
  return api.get('/system/mainframe/justPasswordExpired').then(res => res.data)
}

export function changepwd(user) {
  return api.put(`/system/mainframe/changepwd`, user).then(res => res.data)
}
/**
 * 获取当前用户岗位信息
 */
export function queryPositions() {
  return api.get('system/mainframe/userpositions')
    .then(res => {
      var _data = res.data.map(function (item) {
        return {...item, valueField: item.userStation + '-' + item.userRank + '-' + item.unitCode}
      })
      return _data
    })
}
export function getCurrposition() {
  return api.get('system/mainframe/usercurrposition')
    .then(res => res.data)
}
export function setPosition(id) {
  return api.put(`/system/mainframe/setuserposition/${id}`).then(res => res.data)
}

export function checkcaptcha(picLyanzhengma) {
  return apiAuth.get(`/system/mainframe/checkcaptcha/${picLyanzhengma}`).then(res => res.data)
}

export function getCurrposition2() {
  return loginAuth.get('/usercenter/usercurrposition')
    .then(res => res.data)
}

// 双创登录之前的验证（双创存在，登录，不存在/E交易存在->注册登录
export function scBeforeLogin({username, password}) {
  return loginAuth.post('/usercenter/beforeLogin', {
    loginName: username,
    passWord: password
  }).then(res => res.data)
}
// E交易登录之前的验证
export function EjyBeforeLogin({username, password}) {
  return loginAuth.post('/infoExchange/beforeLoginEjy', {
    loginName: username,
    passWord: password
  }).then(res => {
    if (res.code == 0) {
      return res
    } else if (res.request.response.code == 0) {
      return res.request.response
    }
  })
}
export function csrf() {
  return api.get(`/system/mainframe/login/csrf`)
    .then(res => res.data)
}

export function yjyLogin(u, p) {
  var key = 'kToPG8cQFlg7';
  userlogin(u, p, key, callback);
};
export function callback(data) {
  if (data.code == 0) {
    console.log('E交易登录成功')
  } else {
    console.log(data)
  }
};
export function captchaimage() {
  return request({
    url: '/auth/newlogin/captchaimage',
    method: 'get'
  })
}
export var banUsers = [
  {'loginname': 'jssl123456'},
  {'loginname': 'h123456'},
  {'loginname': 'jshl'},
  {'loginname': 'rwq10'},
  {'loginname': '66666666'},
  {'loginname': 'qwerasdf'},
  {'loginname': '123456'},
  {'loginname': 'ejy365'},
  {'loginname': 'ln123456'},
  {'loginname': 'liuwenjun'},
  {'loginname': '123456789'},
  {'loginname': '0'},
  {'loginname': 'ZY2018'},
  {'loginname': 'hcj2'},
  {'loginname': 'ceshi1'},
  {'loginname': 'czyxjj'},
  {'loginname': 'companyjmr'},
  {'loginname': 'wxm123'},
  {'loginname': 'wuk'},
  {'loginname': 'xuanxuan'},
  {'loginname': 'XUPING'},
  {'loginname': 'companycgdw'},
  {'loginname': 'ceshi'},
  {'loginname': '222222'},
  {'loginname': 'a123456'},
  {'loginname': '9999999999'},
  {'loginname': 'yxyy'},
  {'loginname': 'lkt'},
  {'loginname': '时光'},
  {'loginname': '123133'},
  {'loginname': '12345678'},
  {'loginname': 'abc123'},
  {'loginname': 'ZZJ'},
  {'loginname': 'jinsheng'},
  {'loginname': 'great'},
  {'loginname': '987654321'},
  {'loginname': 'jiangsheng'},
  {'loginname': 'jsns'},
  {'loginname': '1234qwer'},
  {'loginname': 'gxy123456'},
  {'loginname': 'ruixin'},
  {'loginname': '123156'},
  {'loginname': 'changsheng'},
  {'loginname': 'czhz'},
  {'loginname': 'ceshi123'},
  {'loginname': '666666'},
  {'loginname': '123789'},
  {'loginname': 'admin123456'},
  {'loginname': 'jinyuan'},
  {'loginname': 'czty'},
  {'loginname': 'jl123456'},
  {'loginname': 'ym123456'},
  {'loginname': 'yijiang'},
  {'loginname': 'WY'},
  {'loginname': '常州青之峰'},
  {'loginname': '666666666'},
  {'loginname': 'william'},
  {'loginname': '111111'},
  {'loginname': 'shichuang'},
  {'loginname': 'luyoung'},
  {'loginname': 'longwei'},
  {'loginname': 'czgc'},
  {'loginname': 'LZY'},
  {'loginname': 'jzw'},
  {'loginname': '123123'}
]
